import React, { useLayoutEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import shareImg from 'src/assets/share.jpg';
import { CAN_USE_DOM, DOMAIN_URL, SHARES_AND_SEO } from 'src/constants/other';
import { applyHeadTags, buildHeadTagDescriptors, headTagsToReactElements } from 'src/utils/head-tags';

interface Props {
  seo?: {
    title?: string;
    description?: string;
  };
  og?: {
    title?: string;
    description?: string;
    imageUrl?: string;
  };
  canonicalUrl?: string;
}

const Head = (props: Props) => {
  const { seo, og, canonicalUrl } = props;
  const location = useLocation();
  const pageUrl = `${DOMAIN_URL}${location.pathname}${location.search}`;
  const SEO = {
    title: 'seo title',
    description: 'seo description',
    // title: SHARES_AND_SEO.general.title,
    // description: SHARES_AND_SEO.general.description,
    ...seo,
  };
  const OG = {
    title: 'og title',
    description: 'og description',
    imageUrl: '',
    // title: SHARES_AND_SEO.general.shares.title,
    // description: SHARES_AND_SEO.general.shares.subtitle,
    // imageUrl: SHARES_AND_SEO.general.shares.imageUrl,
    ...og,
  };

  const descriptors = useMemo(
    () =>
      buildHeadTagDescriptors({
        title: SEO.title,
        description: SEO.description,
        pageUrl,
        ogTitle: OG.title,
        ogDescription: OG.description,
        ogImageUrl: OG.imageUrl,
        canonicalUrl,
      }),
    [SEO.title, SEO.description, pageUrl, OG.title, OG.description, OG.imageUrl, canonicalUrl]
  );

  useLayoutEffect(() => {
    if (!CAN_USE_DOM) return;

    return applyHeadTags(descriptors);
  }, [descriptors]);

  if (CAN_USE_DOM) {
    return null;
  }

  return <>{headTagsToReactElements(descriptors)}</>;
};

export default Head;
